import { render, staticRenderFns } from "./facilityInfo.vue?vue&type=template&id=04e6719e&scoped=true"
import script from "./facilityInfo.vue?vue&type=script&lang=js"
export * from "./facilityInfo.vue?vue&type=script&lang=js"
import style0 from "./facilityInfo.vue?vue&type=style&index=0&id=04e6719e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6719e",
  null
  
)

export default component.exports